import { Paths } from "configs";

import { Request } from "./Request";
import { RequestCreate } from "./RequestCreate";
import { RequestDetail } from "./RequestDetail";
import { RequestUpdate } from "./RequestUpdate";

export const RequestRoutes = [
  { path: Paths.requestGridPath, element: <Request /> },
  {
    path: Paths.requestCreatePath,
    element: <RequestCreate />,
  },
  {
    path: Paths.requestDetailPath,
    element: <RequestDetail />,
  },
  {
    path: Paths.requestUpdatePath,
    element: <RequestUpdate />,
  },
];
